export class UnitInfo {
  UnitId: number
  UnitCode: string
  UnitName: string
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  CreateByDisplay: string
  UpdateDate: string
  UpdateBy: string
  rowOFFSet: number
  rowFetch: number
}
